import React from "react";
import RetentionLineChart from "./RetentionLineChart";
import RetentionCohortTable from "./RetentionCohortTable";
import RetentionLineTable from "./RetentionLineTable";
/**
 * RetentionVisualization - Main component for displaying retention data
 * Mirrors FunnelVisualization structure
 */
export default function RetentionVisualization({
  intervals = [],
  cohorts = [],
  weightedAverage = null,
  breakdowns = [],
  metric = "retention_rate",
  config = {},
  chartType = "retention-curve",
  startEventLabel = null,
  returnEventLabel = null,
}) {
  const retentionGroupIndex =
    typeof config?.retentionLineIntervalIndex === "number"
      ? config.retentionLineIntervalIndex
      : 0;
  const seriesLabel =
    (startEventLabel || returnEventLabel)
      ? `${startEventLabel || "Start Event"} then ${returnEventLabel || "Return Event"}`
      : "Retention";

  return (
    <div className="w-full">
      <div className="mb-6">
        <RetentionLineChart
          intervals={intervals}
          cohorts={cohorts}
          weightedAverage={weightedAverage}
          breakdowns={breakdowns}
          metric={metric}
          config={config}
          chartType={chartType}
        />
      </div>

      {/* Mixpanel-style line table (only for Line) */}
      {chartType === "line" && (
        <div className="mb-6">
          <RetentionLineTable
            cohorts={cohorts}
            breakdowns={breakdowns}
            metric={metric}
            intervals={intervals}
            retentionGroupIndex={retentionGroupIndex}
            seriesLabel={seriesLabel}
          />
        </div>
      )}

      {/* Cohort Table (only for Retention Curve) */}
      {chartType === "retention-curve" && (
        <div>
          <RetentionCohortTable
            intervals={intervals}
            cohorts={cohorts}
            weightedAverage={weightedAverage}
            breakdowns={breakdowns}
            metric={metric}
            config={config}
          />
        </div>
      )}
    </div>
  );
}
